"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "workUnitAsyncStorage", {
    enumerable: true,
    get: function() {
        return workUnitAsyncStorage;
    }
});
const _asynclocalstorage = require("./async-local-storage");
const workUnitAsyncStorage = (0, _asynclocalstorage.createAsyncLocalStorage)();

//# sourceMappingURL=work-unit-async-storage-instance.js.map